
const CoacheeInviter = function ($scope, $element, invitationInteractor, eventsService, localize) {
  const $ctrl = this;

  $ctrl.$onInit = function () {
    $ctrl.inviteeEmail = '';
    $ctrl.isSubmitting = false;
    this.setUpEnterKey();
  };

  $ctrl.setUpEnterKey = function () {
    document.getElementById('inviteCoacheeEmail').addEventListener('keyup', function (event) {
      event.preventDefault();
      if (event.keyCode == 13) {
        $ctrl.submit();
      }
    })
  };

  $ctrl.submit = function () {
    if ($ctrl.canSubmit()) {
      $ctrl.isSubmitting = true;
      return invitationInteractor.invitePersonToBeCoached($ctrl.inviteeEmail)
        .then(() => {
          $ctrl.inviteeEmail = '';
          $ctrl.concludeSubmission();
        }, () => {
          $ctrl.concludeSubmission();
        });
    }
  };

  $ctrl.concludeSubmission = function () {
    $ctrl.refreshList();
    $ctrl.isSubmitting = false;
    $scope.$digest();
  };

  $ctrl.canSubmit = function () {
    return $ctrl.inviteeEmail && $ctrl.inviteeEmail.length > 0 && !$ctrl.isSubmitting
  };

  // $ctrl.isInviteDisabled = function() {
  //   return $ctrl.inviteeEmail ? $ctrl.inviteeEmail.length === 0 : false
  // };

  $ctrl.downcaseEmail = function () {
    if ($ctrl.inviteeEmail) $ctrl.inviteeEmail = $ctrl.inviteeEmail.toLowerCase();
  };
};

export default {
  name: 'coacheeInviter',
  obj: {
    controller: CoacheeInviter,
    templateUrl: 'components/coachee_inviter.html',
    bindings: {
      refreshList: '&'
    }
  },
  deps: []
}